// extracted by mini-css-extract-plugin
module.exports = {"methodsTextContainer":"BoxDescriptionWithLetterHeading_methodsTextContainer__KerqP"};